export function addTranslateHotkey(hotkeys, fdTranslate, translateModalService) {
  'ngInject';
  if (fdTranslate.options.hotkey) {
    hotkeys.add({
      combo: 'ctrl+t',
      description: 'Add new translation',
      callback: () => {
        translateModalService.open();
      }
    });
  }
}
